/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import { Box, Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import AutoCompleteDropdown from "../../../components/common/new/AutoCompleteDropdown/AutoCompleteDropdown";
import InputField from "../../../components/common/new/InputField/InputField";
import useQueryParams from "../../../hooks/useQueryParams";
import {
  SET_CITIES,
  SET_DIVISIONS,
  SET_STATES,
  SET_SUB_DIVISIONS,
} from "../../../redux/actionTypes/meta";
import IntroductionFormApi from "../../../services/api/introductionForm";
import { getOptions } from "../../../utils";
import { isEmptyObj } from "../../../utils/helper";
import Styles from "../EmailerRecipients/EmailerReceipients.styles";

function PersonalDetailsSearch() {
  const [stateVal, setStateVal] = useState("");
  const [divisionVal, setDivisionVal] = useState("");
  const [subDivisionVal, setSubDivisionVal] = useState("");
  const [cityVal, setCityVal] = useState("");
  const [divisions, setDivisions] = useState([]);
  const [subDivisions, setSubDivisions] = useState([]);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const dispatch = useDispatch();
  const { getQueryObject, getQueryParams, urlSearchParams } = useQueryParams();

  const setMetaDataInRedux = (type, payload) => {
    dispatch({
      type,
      payload,
    });
  };

  const getDivisions = async () => {
    const response = await IntroductionFormApi.getDivisions();
    setDivisions(response.data);
    setMetaDataInRedux(SET_DIVISIONS, response.data);
  };

  const getStates = async () => {
    const response = await IntroductionFormApi.getStates();
    setStates(response.data);
    setMetaDataInRedux(SET_STATES, response.data);
  };

  useEffect(() => {
    getDivisions();
    getStates();
  }, []);

  useEffect(() => {
    const queryObject = getQueryObject();
    if (!isEmptyObj(queryObject)) {
      const query = getQueryParams(queryObject)[0];
      setStateVal(query?.stateId || "");
      setCityVal(query?.cityId || "");
      setDivisionVal(query?.divisionId || "");
      setSubDivisionVal(query?.subdivisionId || "");
    } else {
      setStateVal("");
      setCityVal("");
      setDivisionVal("");
      setSubDivisionVal("");
    }
  }, [urlSearchParams.toString()]);

  useEffect(() => {
    if (states.length && stateVal) {
      const newCities =
        states.find((state) => state.stateId === Number(stateVal))?.cities ??
        [];
      setCities(newCities);
      setMetaDataInRedux(SET_CITIES, newCities);
    }
  }, [states, stateVal]);

  useEffect(() => {
    if (divisions.length && divisionVal) {
      const newSubDivisions =
        divisions.find(
          (division) => division.divisionId === Number(divisionVal)
        )?.subDivisions ?? [];
      setSubDivisions(newSubDivisions);
      setMetaDataInRedux(SET_SUB_DIVISIONS, newSubDivisions);
    }
  }, [divisions, divisionVal]);

  return (
    <Box>
      <Box sx={{ width: "100%" }}>
        <Grid container rowSpacing={4} columnSpacing={5}>
          <Grid item xs={6}>
            <InputField
              label="Member Id"
              name="id"
              style={Styles.textfieldStyle}
            />
          </Grid>
          <Grid item xs={6}>
            <InputField
              label="Member Name"
              name="fullName"
              style={Styles.textfieldStyle}
            />
          </Grid>
          <Grid item xs={6}>
            <InputField
              label="Phone Number"
              name="mobileNumber"
              type="text"
              style={Styles.textfieldStyle}
              inputProps={{
                maxLength: 10,
              }}
            />
          </Grid>
          <Grid item xs={6}>
            <InputField
              label="Email Id"
              name="emailId"
              style={Styles.textfieldStyle}
              type="email"
            />
          </Grid>
          <Grid item xs={6}>
            <InputField
              label="Address"
              name="address"
              style={Styles.textfieldStyle}
            />
          </Grid>
          <Grid item xs={6}>
            <InputField
              label="Pincode"
              type="text"
              name="pincode"
              style={Styles.textfieldStyle}
              inputProps={{
                maxLength: 6,
              }}
            />
          </Grid>
          <Grid item xs={6}>
            <AutoCompleteDropdown
              getOptionLabel={(option) => option.stateName}
              label="State"
              name="stateId"
              options={getOptions(states, "stateId")}
              value={stateVal}
              style={Styles.dropdownfieldStyle}
              inputProps={{ required: false }}
              onChange={(selectedValue) => {
                if (!selectedValue) {
                  setStateVal("");
                  setCities([]);
                } else {
                  setStateVal(selectedValue.value);
                  setCities(selectedValue.cities);
                  setMetaDataInRedux(SET_CITIES, selectedValue.cities);
                }
              }}
              useHiddenInput
            />
          </Grid>
          <Grid item xs={6}>
            <AutoCompleteDropdown
              getOptionLabel={(option) => option.cityName}
              label="City"
              name="cityId"
              options={getOptions(cities, "cityId")}
              value={cityVal}
              style={Styles.dropdownfieldStyle}
              disabled={!stateVal}
              inputProps={{ required: false }}
              onChange={(selectedValue) => {
                if (!selectedValue) {
                  setCityVal("");
                } else {
                  setCityVal(selectedValue.value);
                }
              }}
              useHiddenInput
            />
          </Grid>
          <Grid item xs={6}>
            {" "}
            <AutoCompleteDropdown
              getOptionLabel={(option) => option.shortName}
              label="Division"
              name="divisionId"
              options={getOptions(divisions, "divisionId")}
              value={divisionVal}
              style={Styles.dropdownfieldStyle}
              inputProps={{ required: false }}
              onChange={(selectedValue) => {
                if (!selectedValue) {
                  setDivisionVal("");
                  setSubDivisions([]);
                } else {
                  setDivisionVal(selectedValue.value);
                  setSubDivisions(selectedValue.subDivisions);
                  setMetaDataInRedux(
                    SET_SUB_DIVISIONS,
                    selectedValue.subDivisions
                  );
                }
              }}
              useHiddenInput
            />
          </Grid>
          <Grid item xs={6}>
            {" "}
            <AutoCompleteDropdown
              getOptionLabel={(option) => option.name}
              label="Sub Division"
              name="subdivisionId"
              options={getOptions(subDivisions, "divisionId")}
              value={subDivisionVal}
              style={Styles.dropdownfieldStyle}
              disabled={!divisionVal}
              onChange={(selectedValue) => {
                if (!selectedValue) {
                  setSubDivisionVal("");
                } else {
                  setSubDivisionVal(selectedValue.value);
                }
              }}
              useHiddenInput
            />
          </Grid>
        </Grid>
      </Box>
      <Grid item md={8} sm={12} spacing={2} />
    </Box>
  );
}

export default PersonalDetailsSearch;
